import React, { useEffect } from 'react';
import './context/index.js';
import './utils/logToSlack.js';
import './animations--PMkOS0j.js';
import 'cookies-next';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-YC9H491Y.js';
import './index-xPaCrlMu.js';
import 'next/router';
import useOnScreen from './hooks/useOnScreen.js';
import 'notistack';
import 'next-i18next';
import 'lodash/get';
import './product-_pRduMz7.js';
import './helpers-kA_hdoOI.js';
import 'lodash';

const ScreenDetector = ({ onScreenDetected }) => {
    const [isOnScreen, lazyRef] = useOnScreen(0, true);
    useEffect(() => {
        if (!isOnScreen)
            return;
        onScreenDetected();
    }, [isOnScreen]);
    return React.createElement("div", { ref: lazyRef });
};

export { ScreenDetector as S };
//# sourceMappingURL=ScreenDetector-lL70CaMo.js.map
